var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDetailsDots(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 6,
    viewBox: "0 0 25 6",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.125 0C1.40625 0 0 1.35 0 3C0 4.65 1.40625 6 3.125 6C4.84375 6 6.25 4.65 6.25 3C6.25 1.35 4.84375 0 3.125 0ZM21.875 0C20.1562 0 18.75 1.35 18.75 3C18.75 4.65 20.1562 6 21.875 6C23.5937 6 25 4.65 25 3C25 1.35 23.5937 0 21.875 0ZM12.5 0C10.7812 0 9.375 1.35 9.375 3C9.375 4.65 10.7812 6 12.5 6C14.2187 6 15.625 4.65 15.625 3C15.625 1.35 14.2187 0 12.5 0Z",
    fill: "#7B737B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDetailsDots);
export default __webpack_public_path__ + "static/media/details_dots.4ce1135a4a042f80d35b19e9c5f07cfe.svg";
export { ForwardRef as ReactComponent };